import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ExecutiveDashboardsService } from "@shared/services/executive-dashboards.service";

@Component({
  selector: 'app-executive-dashboard-trend-reports',
  templateUrl: './executive-dashboard-trend-reports.component.html',
})
export class ExecutiveDashboardTrendReportsComponent implements OnInit ,OnChanges {

  @Input() teamId: string;
  @Input() selectedDate: { from: any; to: any };

  availableSeverities: { key: string, value: string }[] = [];
  selectedSeverities: string[] = [];

  activeTrendReportsTab = 0;

  loadingTotalCodeQualityIndexData = false;
  noTotalCodeQualityIndexChart = false;
  totalCodeQualityIndexTypeChartOption: any;
  totalCodeQualityIndexChartData: any;

  loadingTCQIBreakdownData = false;
  noTCQIBreakdownChart = false;
  totalTCQIBreakdownChartOption: any;
  totalTCQIBreakdownChartData: any;

  loadingCriticalIssuesData = false;
  noCriticalIssuesChart = false;
  criticalIssuesChartOption: any;
  totalCriticalIssuesChartData: any;
  labelPositions = ['insideTop', 'inside', 'insideBottom'];
  private hasInitializedSeverity = false;
  nodeAllTeams: any;
  isDropdownOpen: boolean;
  selectedTeamFilter: any;
  selectedTeamKeys: string[] = [];

  constructor(private executiveDashboardsService: ExecutiveDashboardsService) {}

  ngOnInit(): void {
    this.selectedTeamKeys = [];
    this.selectedTeamFilter = undefined;

    this.tabIndexChangeProjectIssues(0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDate && changes.selectedDate.currentValue) {
      this.tabIndexChangeProjectIssues(this.activeTrendReportsTab);
    }
  }

  convertTeamsToNzTreeFormat(teams: any[]): any[] {
    if (!teams) { return []; }
    return teams.map(team => ({
      title: team.teamName,
      key: team.key,
      teamId: team.teamId,
      children: this.convertTeamsToNzTreeFormat(team.children || [])
    }));
  }

  getSelectedTeamIds(filterTeams: any): string[] {
    const selectedTeamIds = [];
    for (const key of filterTeams) {
      const selectedNode = this.findNodeByKey(key, this.nodeAllTeams);
      if (selectedNode) {
        selectedTeamIds.push(selectedNode.teamId);
      }
    }
    return selectedTeamIds ;
  }

  findNodeByKey(key: string, nodes: any[]): any {
    for (const node of nodes) {
      if (node.key === key) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const foundNode = this.findNodeByKey(key, node.children);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  }

  onSeverityFilterChange(selected: string[]): void {
    this.selectedSeverities = selected;
    this.loadTrendReportsCharts('CODE_QUALITY_INDEX_CRITICAL_ISSUES');
  }

  onChangeUpperlevelSelectTeams(selected: string[]): void {
    this.isDropdownOpen = true;
    this.selectedTeamKeys = selected;
    this.selectedTeamFilter = this.getSelectedTeamIds(selected);
    this.loadTrendReportsCharts('CODE_QUALITY_INDEX_TEAM_PROJECT');
  }


  tabIndexChangeProjectIssues(tabIndex: number): void {
    this.activeTrendReportsTab = tabIndex;

    switch (tabIndex) {
      case 0:
        this.loadTrendReportsCharts('TOTAL_CODE_QUALITY_INDEX');
        break;
      case 1:
        this.loadTrendReportsCharts('CODE_QUALITY_INDEX_TEAM_PROJECT');
        break;
      case 2:
        this.loadTrendReportsCharts('CODE_QUALITY_INDEX_CRITICAL_ISSUES');
        break;
    }
  }

  loadTrendReportsCharts(chartType:any): void {
    this.loadingTotalCodeQualityIndexData = true;
    this.loadingTCQIBreakdownData = true;
    this.loadingCriticalIssuesData = true;
    let selectedFilters: any;

    if (chartType === 'CODE_QUALITY_INDEX_CRITICAL_ISSUES') {
      selectedFilters = {
        severity: this.selectedSeverities.length > 0 ? this.selectedSeverities : []
      };
    }

    if (chartType === 'CODE_QUALITY_INDEX_TEAM_PROJECT' && this.selectedTeamKeys?.length > 0) {
      selectedFilters = {
        team: this.getSelectedTeamIds(this.selectedTeamKeys)
      };
    }


    this.executiveDashboardsService
      .getTeamsData(
        this.teamId,
        chartType,
        this.selectedDate.from,
        this.selectedDate.to,
        selectedFilters
      ).subscribe((response) => {
        switch (chartType) {
          case 'TOTAL_CODE_QUALITY_INDEX':
            this.totalCodeQualityIndexChartData = response.data
            this.TrendReportsCodeQualityCharts('TOTAL_CODE_QUALITY_INDEX', this.totalCodeQualityIndexChartData);
            this.loadingTotalCodeQualityIndexData = false;
            break;
          case 'CODE_QUALITY_INDEX_TEAM_PROJECT':
            this.totalTCQIBreakdownChartData = response.data;
            this.nodeAllTeams = this.convertTeamsToNzTreeFormat(this.totalTCQIBreakdownChartData.teams);
            this.TrendReportsCodeQualityCharts('CODE_QUALITY_INDEX_TEAM_PROJECT', this.totalTCQIBreakdownChartData);
            this.loadingTCQIBreakdownData = false;
            break;
          case 'CODE_QUALITY_INDEX_CRITICAL_ISSUES':

            this.totalCriticalIssuesChartData = response.data;
            const severities = response.data?.severities || [];
            this.availableSeverities = severities;
            if (!this.hasInitializedSeverity && this.selectedSeverities.length === 0) {
              this.hasInitializedSeverity = true;
            }
            this.TrendReportsCodeQualityCharts('CODE_QUALITY_INDEX_CRITICAL_ISSUES', this.totalCriticalIssuesChartData);
            this.loadingCriticalIssuesData = false;
            break;
        }
      });
  }

  TrendReportsCodeQualityCharts(chartType:any,chartData: any): void {
    switch (chartType) {
      case 'TOTAL_CODE_QUALITY_INDEX':
        const chartXAxisTotalCodeQualityIndex = chartData?.xaxis || [];
        if (!chartXAxisTotalCodeQualityIndex?.length) {
          this.noTotalCodeQualityIndexChart =  true;
          this.loadingTotalCodeQualityIndexData = false;
        } else {
          this.totalCodeQualityIndexTypeChartOption = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: { color: '#999' }
              }
            },
            toolbox: {
              feature: {
                saveAsImage: { title: 'Save as Image' }
              }
            },
            legend: {
              data: chartData.series.map(s => s.name)
            },
            dataZoom: [
              {
                type: 'slider', // Enables zoom via slider
                show: true,
                xAxisIndex: 0,
                start: 0,
                end: 100
              },
              {
                type: 'inside', // Enables zoom via mouse wheel or pinch
                xAxisIndex: 0,
                start: 0,
                end: 100
              }
            ],
            xAxis: [
              {
                type: 'category',
                data: chartXAxisTotalCodeQualityIndex,
                axisPointer: {
                  type: 'shadow'
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: 'Value',
                min: 0,
                max: 5,
                interval: 1,
                axisLabel: { formatter: '{value}' }
              }
            ],
            series: chartData.series.map((s, index) => {
              const blueShades = ['#1d4277', '#1278d3', '#6FAEDB', 'rgba(71,71,71,0.6)'];
              const color = blueShades[index % blueShades.length];
              return {
                name: s.name,
                type: s.type,
                smooth: s.type === 'line',
                tooltip: {
                  valueFormatter: (value: number) => value.toFixed(2)
                },
                data: s.data.map(Number),
                barGap: '0%',
                barWidth: '20%',
                z: s.type === 'line' ? 10 : 1,
                itemStyle: {
                  color
                },
                lineStyle: s.type === 'line' ? { color } : undefined,
                label: {
                  show: true,
                  position: this.labelPositions[index % this.labelPositions.length],
                  backgroundColor: s.type === 'line' ? '#ccc' : 'rgba(76,76,76,0.57)',
                  color: s.type === 'line' ? '#000' : '#fff',
                  fontWeight: 'bold',
                  padding: [2, 4],
                  borderRadius: 2
                }
              };
            })
          };

        }
        break;
      case 'CODE_QUALITY_INDEX_TEAM_PROJECT':
        const chartXAxisTCQIBreakdown = chartData?.xaxis || [];
        const chartXAxisTCQIBreakdownSecond = chartData?.xaxisSecond || [];
        if (!chartXAxisTCQIBreakdown?.length) {
          this.noTCQIBreakdownChart =  true;
          this.loadingTCQIBreakdownData = false;
        } else {
          this.noTCQIBreakdownChart =  false;
          const blueShades = ['#1d4277', '#1278d3', '#3171ed', '#83C1E3'];
          let dataZoomConfig = [];
          const xAxisLength = chartXAxisTCQIBreakdown.length;
          if (xAxisLength > 4) {
            const viewSize = 4;
            const maxViewSize = 5;
            const endPercent = (viewSize / xAxisLength) * 100;
            const spanPercent = (maxViewSize / xAxisLength) * 100;
            dataZoomConfig = [
              {
                type: 'slider',
                xAxisIndex: [0, 1],
                start: 0,
                end: endPercent,
                minSpan: spanPercent,
                maxSpan: spanPercent
              },
              {
                type: 'inside',
                xAxisIndex: [0, 1],
                start: 0,
                end: endPercent,
                minSpan: spanPercent,
                maxSpan: spanPercent
              }
            ];
          }
          const goal = chartData?.goal;
          this.totalTCQIBreakdownChartOption = {
            tooltip: {
              trigger: 'axis',
              formatter (params) {
                const dataIndex = params[0].dataIndex;
                let bottomLabel = chartXAxisTCQIBreakdown[dataIndex];
                const topLabel = chartXAxisTCQIBreakdownSecond[dataIndex];
                if (bottomLabel.length > 50) {
                  bottomLabel = bottomLabel.slice(0, 50) + '<br/>' + bottomLabel.slice(50);
                }
                let tooltipContent = `<strong>${topLabel} <br/> ${bottomLabel}</strong><br/>`;
                tooltipContent += `<span style="display: inline-block;width: 9px; height: 9px; border-radius: 50%;background-color: #FF0000;margin-right: 8px"></span>Goal:  ${goal}<br/> `;
                params.forEach(item => {
                  tooltipContent += `${item.marker} ${item.seriesName}: ${item.data}<br/>`;
                });
                return tooltipContent;
              }
            },
            toolbox: {
              feature: {
                saveAsImage: { title: 'Save as Image' },
              }
            },
            legend: {
              data: chartData.series.map(s => s.name)
            },
            grid: {
              top: 80,
              left: 50,
              right: 30,
              bottom: 60
            },
            xAxis: [
              {
                type: 'category',
                data: chartXAxisTCQIBreakdown,
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  show: true
                },
                axisLabel: {
                  show: true,
                  interval: 0,
                  rotate: 0,
                  formatter(value) {
                    return ( value.length > 13 && xAxisLength > 4 ) ? value.slice(0, 13) + '...' : ( value.length > 13 && xAxisLength <= 4 ) ? value.slice(0, 22) + '...' : value;
                  }
                },
              },
              {
                type: 'category',
                data: chartXAxisTCQIBreakdownSecond,
                position: 'top',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  show: true
                },
                axisLabel: {
                  show: true,
                  interval: 0,
                  rotate:0,
                  formatter(value) {
                    return ( value.length > 13 && xAxisLength > 4 ) ? value.slice(0, 13) + '...' : ( value.length > 13 && xAxisLength <= 4 ) ? value.slice(0, 22) + '...' : value;
                  }
                }
              }
            ],
            yAxis: {
              type: 'value',
              min: 0,
              max: 5
            },
            dataZoom: dataZoomConfig,
            series: chartData.series.map((s, index) => ({
              ...s,
              itemStyle: {
                color: blueShades[index % blueShades.length]
              },
              lineStyle: s.type === 'line' ? { color: blueShades[index % blueShades.length] } : undefined,
              label: {
                show: true,
                position: this.labelPositions[index % this.labelPositions.length],
                backgroundColor: s.type === 'line' ? '#ccc' : 'rgba(76,76,76,0.57)',
                color: s.type === 'line' ? '#000' : '#fff',
                fontWeight: 'bold',
                padding: [3, 3],
                borderRadius: 2
              },
              ...(index === 0 && {
                markLine: {
                  name: 'Goal Line',
                  symbol: 'none',
                  label: {
                    show: true,
                    formatter: 'Goal  ',
                    padding: [10, 10],
                    position: 'start',
                    fontWeight: 'bold',
                    fontSize: '10',
                    color: '#FF0000'
                  },
                  lineStyle: {
                    color: '#FF0000',
                    width: 2,
                    type: 'solid',
                  },
                  data: [
                    { yAxis: goal }
                  ]
                }
              })
            }))
          };

        }
        break;
      case 'CODE_QUALITY_INDEX_CRITICAL_ISSUES':
        const chartXAxisScriticalIssues = chartData?.xaxis || [];
        if (!chartXAxisScriticalIssues?.length) {
          this.noCriticalIssuesChart =  true;
          this.loadingCriticalIssuesData = false;
        } else {
          const blueShades = ['#1d4277', '#1278d3', '#6FAEDB', '#83C1E3'];
          let dataZoomConfigIssues = [];
          const xAxisLengthIssues = chartXAxisScriticalIssues.length;

          if (xAxisLengthIssues > 4) {

            const viewSizeIssues = 4;
            const maxViewSizeIssues = 5;
            const endPercentIssues = (viewSizeIssues / xAxisLengthIssues) * 100;
            const spanPercentIssues = (maxViewSizeIssues / xAxisLengthIssues) * 100;

            dataZoomConfigIssues = [
              {
                type: 'slider',
                xAxisIndex: 0,
                start: 0,
                end: endPercentIssues,
                minSpan: spanPercentIssues,
                maxSpan: spanPercentIssues
              },
              {
                type: 'inside',
                xAxisIndex: 0,
                start: 0,
                end: endPercentIssues,
                minSpan: spanPercentIssues,
                maxSpan: spanPercentIssues
              }
            ];
          }
          this.criticalIssuesChartOption = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: { color: '#999' }
              }
            },
            toolbox: {
              feature: {
                saveAsImage: { title: 'Save as Image' },
              }
            },
            legend: {
              data: chartData.series.map(s => s.name)
            },
            xAxis: [
              {
                type: 'category',
                data: chartXAxisScriticalIssues,
                axisPointer: {
                  type: 'shadow'
                },
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  show: true
                },
                axisLabel: {
                  show: true,
                  interval: 0,
                  rotate: 0,
                  formatter(value) {
                    return ( value.length > 13 && xAxisLengthIssues > 4 ) ? value.slice(0, 13) + '...' : ( value.length > 13 && xAxisLengthIssues <= 4 ) ? value.slice(0, 22) + '...' : value;
                  }
                },

              }
            ],
            yAxis: [
              {
                type: 'value',
                name: 'Value',
                min: 0,
                axisLabel: { formatter: '{value}' }
              }
            ],
            dataZoom: dataZoomConfigIssues,
            series: chartData.series.map((s, index) => ({
              name: s.name,
              type: s.type,
              smooth: s.type === 'line',
              tooltip: {
                valueFormatter: (value: number) => value.toFixed(2)
              },
              data: s.data.map(Number),
              barGap: '0%',
              barWidth: '20%',
              z: s.type === 'line' ? 10 : 1,
              itemStyle: {
                color: blueShades[index % blueShades.length]
              },
              lineStyle: s.type === 'line' ? { color: blueShades[index % blueShades.length] } : undefined,
              label: {
                show: true,
                position: (this.labelPositions)[index % this.labelPositions.length],
                backgroundColor: s.type === 'line' ? '#ccc' : 'rgba(76,76,76,0.57)',
                color: s.type === 'line' ? '#000' : '#fff',
                fontWeight: 'bold',
                padding: [2, 4],
                borderRadius: 2
              }
            }))
          };

        }
        break;
    }
}
}
